import { useState } from "react";
import Button from "../../../common/Button";
import Input from "../../../common/Input";
import { useDispatch } from "react-redux";
import {
  removeDoctor,
} from "../../../../redux/Thunk/Doctor/DoctorThunks";
import { paymentOptions } from "../../../../utils/constants";
import { setActiveForm } from "../../../../redux/Reducer/Admin/PartnerSlice";
import Warning from "../../../common/icons/Warning";
import Edit from "../../../common/icons/Edit";
import Verifed from "../../../common/icons/Verifed";
import CloseBg from "../../../common/icons/CloseBg";

const Payment = (props) => {
  const {
    formik,
    isCreateAccount,
    formattedDate,
    selectedOption,
    setSelectedOption,
    handleEditToggle,
    isEdit,
    handleEditIconClick,
    handleBlur,
    editingField,
    setShowEditIcon,
    isDisabled,
    showEditIcon,
    resetValues,
    doctorById,
  } = props;
  const { values, handleChange, touched, errors, setFieldTouched } = formik;

  const [isShow, setIsShow] = useState(false);

  const dispatch = useDispatch();

  const handleOptionChange = (value) => {
    // formik.setFieldValue("paymentMethod", value);
    setSelectedOption(value);
  };

  const handleRemoveDoctor = () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this account?"
    );
    if (confirmDelete) {
      dispatch(removeDoctor(values.doctorDetails.DID));
      formik.resetForm();
    }
  };

  const handleCloseForm = () => {
    setIsShow(false);
  };
  const handleShowButtons = () => {
    setIsShow(true);
  };
  const handleCancelForm = () => {
    dispatch(setActiveForm(null));
    formik.resetForm({
      values: formik.initialValues,
    });
  };

  return (
    <div className="mb-3">
      <h2 className="text-black-lose text-[13px] font-medium mb-2">Payment</h2>
      <div className="grid grid-cols-12 gap-[8px]">
        <div className="col-span-12">
          <div className="flex items-center gap-[12px] mb-3">
            {paymentOptions?.map((option) => (
              <label
                key={option.value}
                className="cus-radio text-black-lose text-[16px] flex items-center gap-[8px] relative cursor-pointer"
              >
                <div>
                  <input
                    disabled={!showEditIcon && isDisabled}
                    type="radio"
                    name="payment"
                    value={option?.value}
                    checked={selectedOption === option.value}
                    onChange={() => handleOptionChange(option.value)}
                    className="absolute left-0 top-0 opacity-0"
                  />
                  <span className="radio-box"></span>
                </div>
                {option.label}
              </label>
            ))}
          </div>
        </div>

        {selectedOption === "bank" ? (
          <>
            <div className="col-span-12 md:col-span-6">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="text"
                labelName="Account Number*"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                name="paymentDetails.bankAccountNumber"
                id="paymentDetails.bankAccountNumber"
                value={values?.paymentDetails?.bankAccountNumber}
                onChange={(e) => {
                  handleChange(e);
                  setFieldTouched(
                    "paymentDetails.bankAccountNumber",
                    true,
                    false
                  );
                }}
                isError={
                  touched?.paymentDetails?.bankAccountNumber &&
                  Boolean(errors?.paymentDetails?.bankAccountNumber)
                }
                errorMessage={errors?.paymentDetails?.bankAccountNumber}
                disabled={
                  isDisabled &&
                  editingField !== "paymentDetails.bankAccountNumber"
                }
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur
                    ? handleBlur("paymentDetails.bankAccountNumber")
                    : ""
                }
                onEditClick={() =>
                  handleEditIconClick("paymentDetails.bankAccountNumber")
                }
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>
            <div className="col-span-12 md:col-span-6">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="text"
                labelName="Account Holder Name*"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                name="paymentDetails.accountName"
                id="paymentDetails.accountName"
                value={values?.paymentDetails?.accountName}
                onChange={handleChange}
                isError={
                  touched?.paymentDetails?.accountName &&
                  Boolean(errors?.paymentDetails?.accountName)
                }
                errorMessage={errors?.paymentDetails?.accountName}
                disabled={
                  isDisabled && editingField !== "paymentDetails.accountName"
                }
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur ? handleBlur("paymentDetails.accountName") : ""
                }
                onEditClick={() =>
                  handleEditIconClick("paymentDetails.accountName")
                }
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>
            <div className="col-span-12 md:col-span-6">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="text"
                labelName="Bank Name*"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                name="paymentDetails.bankName"
                id="paymentDetails.bankName"
                value={values?.paymentDetails?.bankName}
                onChange={handleChange}
                isError={
                  touched?.paymentDetails?.bankName &&
                  Boolean(errors?.paymentDetails?.bankName)
                }
                errorMessage={errors?.paymentDetails?.bankName}
                disabled={
                  isDisabled && editingField !== "paymentDetails.bankName"
                }
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur ? handleBlur("paymentDetails.bankName") : ""
                }
                onEditClick={() =>
                  handleEditIconClick("paymentDetails.bankName")
                }
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>
            <div className="col-span-12 md:col-span-6">
              <Input
                placeholder="Enter"
                inputBox="mb-0"
                type="text"
                labelName="IFSC Code*"
                labelClassName="block text-primary-400 text-[13px] leading-[20px]"
                className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
                name="paymentDetails.ifscName"
                id="paymentDetails.ifscName"
                value={values?.paymentDetails?.ifscName}
                onChange={handleChange}
                isError={
                  touched?.paymentDetails?.ifscName &&
                  Boolean(errors?.paymentDetails?.ifscName)
                }
                errorMessage={errors?.paymentDetails?.ifscName}
                disabled={
                  isDisabled && editingField !== "paymentDetails.ifscName"
                }
                showEditIcon={isEdit}
                onBlur={() =>
                  handleBlur ? handleBlur("paymentDetails.ifscName") : ""
                }
                onEditClick={() =>
                  handleEditIconClick("paymentDetails.ifscName")
                }
                disabledClass="bg-primary-50 border-primary-50 "
              />
            </div>
          </>
        ) : (
          <div className="col-span-6">
            <Input
              placeholder="Enter"
              inputBox="mb-0"
              type="text"
              labelName="UPI ID*"
              labelClassName="block text-primary-400 text-[13px] leading-[20px]"
              className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
              name="paymentDetails.upiId"
              id="paymentDetails.upiId"
              value={values?.paymentDetails?.upiId}
              onChange={handleChange}
              isError={
                touched?.paymentDetails?.upiId &&
                Boolean(errors?.paymentDetails?.upiId)
              }
              errorMessage={errors?.paymentDetails?.upiId}
              disabled={isDisabled && editingField !== "paymentDetails.upiId"}
              showEditIcon={isEdit}
              onBlur={() =>
                handleBlur ? handleBlur("paymentDetails.upiId") : ""
              }
              onEditClick={() => handleEditIconClick("paymentDetails.upiId")}
              disabledClass="bg-primary-50 border-primary-50 "
            />
          </div>
        )}

        <div className="mb-2 col-span-12">
          <h2 className="text-black-lose text-[13px] font-medium mb-2">
            Digital Signature & Settings
          </h2>
          <div className="flex items-center justify-start gap-1 mb-3">
            <span>
              {values?.doctorDetails?.autoSignature ? <Verifed height={30} width={30} fill="#00C732" /> : <CloseBg height={26} width={26} fill="#8E1010" />}
            </span>
            <h4 className="text-[16px] font-medium text-black-lose">Smart Order {values?.doctorDetails?.autoSignature ? "Enabled" : "Disbled"} </h4>
          </div>
          <div className="flex items-center justify-start gap-1 mb-3">
            <span>
              {values?.doctorDetails?.autoReceiptSignature ? <Verifed height={30} width={30} fill="#00C732" /> : <CloseBg height={26} width={26} fill="#8E1010" />}
            </span>
            <h4 className="text-[16px] font-medium text-black-lose">Smart Receipt {values?.doctorDetails?.autoReceiptSignature ? "Enabled" : "Disabled"} </h4>
          </div>
        </div>

        <div className="col-span-12">
          <p className="text-[13px] font-medium text-primary-400">
            Account created on {formattedDate}
          </p>
        </div>
        <div className="col-span-12">
          {isCreateAccount && !isShow ? (
            <div className="flex items-center gap-2">
              <Button
                className="bg-primary-600 h-[36px] text-white py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                onClick={handleShowButtons}
                type="button"
              >
                <Edit />
                Register Account
              </Button>
              <Button
                className="border-primary-600 border h-[36px] text-secondry-600 py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                type="button"
                onClick={handleCancelForm}
              >
                Cancel
              </Button>
            </div>
          ) : isShow ? (
            <div className="flex items-center gap-2">
              <Button
                className="border-primary-600 border h-[36px] text-secondry-600 py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                type="button"
                onClick={handleCloseForm}
              >
                Cancel
              </Button>
              <Button
                className="border-primary-600 border text-secondry-600 h-[36px] py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                type="submit"
              >
                Register Account
              </Button>
              <Button
                className="bg-primary-600 text-white h-[36px] py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                type="button"
              >
                Send OTP
              </Button>
            </div>
          ) : (
            <div className="flex items-center gap-2">
              {!isEdit ? (
                <Button
                  className="bg-primary-600 h-[36px] text-white py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                  onClick={handleEditToggle}
                  type="button"
                >
                  <Edit />
                  Edit Details
                </Button>
              ) : (
                <Button
                  className="border-primary-600 border text-secondry-600 h-[36px] py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                  onClick={() => {
                    const newValues = resetValues(doctorById);
                    formik.setValues(newValues);

                    setShowEditIcon(false);
                  }}
                  type="button"
                >
                  Cancel
                </Button>
              )}
              {!isEdit ? (
                <Button
                  className="bg-primary-600 border text-white h-[36px] py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                  onClick={handleRemoveDoctor}
                  type="button"
                >
                  <Warning fill="#F8F6F6" />
                  Delete Account
                </Button>
              ) : (
                <Button
                  className="border-primary-600 border text-secondry-600 h-[36px] py-2 px-5 min-w-[136px] text-[13px] leading-[20px] rounded-full flex items-center justify-center gap-2 shadow-none outline-none"
                  type="submit"
                >
                  <Edit fill="#7C6060" />
                  Save Details
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Payment;
